import React, { useCallback, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";
import DanhSachCuaHangApi from "service/danhSachCuaHangApi";

const ThemSuaCuaHang = ({ onClose, onSearch, data }) => {
  const [Code, setCode] = useState(data?.Code ?? "");
  const [CompanyID] = useState(data?.CompanyID);
  const [Name, setName] = useState(data?.Name ?? "");
  const [Address, setAddress] = useState(data?.Address ?? "");
  const [Phone, setPhone] = useState(data?.Phone ?? "");
  const [Status, setStatus] = useState(data?.Status ?? "");
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});
  const handleKeyDown = (event) => {
    if (event.key === "Escape") onClose();
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    if (data?.CompanyID === 0) {
      loadNewCode();
    }

    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);
  const validate = () => {
    let newErrors = {};
    if (!Code.trim()) newErrors.Code = "Nhập mã";
    if (!Name.trim()) newErrors.Name = "Nhập tên";
    if (!Address.trim()) newErrors.Address = "Nhập địa chỉ";
    if (!Phone.trim()) newErrors.Phone = "Nhập số điện thoại";
    return newErrors;
  };
  const loadNewCode = useCallback(async () => {
    try {
      const res = await DanhSachCuaHangApi.getNewCode();
      setCode(res.data || "");
    } catch (error) {
      console.error("Lỗi load new code:", error);
    }
  }, []);
  const onSaveThemSuaCuaHang = async (data) => {
    let success = "";
    let error = "";
    try {
      const res = await DanhSachCuaHangApi.addorupdate(data);
      const dataResponse = res.data;
      if (res.status === 200) {
        if (data.CompanyID !== 0) {
          success = "Sửa cửa hàng thành công.";
          onClose();
        } else {
          success = "Thêm mới cửa hàng thành công.";
          onClose();
        }
        pushNotification(success, "success", "TOP_CENTER", 1000);
        onSearch();
      } else {
        if (data.CompanyID !== 0) {
          error = "Sửa cửa hàng thất bại!";
        } else {
          error = dataResponse.Messages;
          console.log("Error: ", error);
        }
        pushNotification(error, "error", "TOP_CENTER", 1000);
      }
    } catch (err) {
      console.error("Lỗi:", err);
      if (data.CompanyID !== 0) {
        error = "Lỗi khi gọi Api Sửa cửa hàng!";
      } else {
        error = "Lỗi khi gọi Api Thêm mới cửa hàng!";
      }
      pushNotification(error, "error", "TOP_CENTER", 1000);
    }
  };
  const handleSave = async () => {
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setErrors({});
    try {
      setSaving(true); // Bắt đầu trạng thái loading
      const payload = {
        CompanyID: CompanyID,
        Name: Name,
        Code: Code,
        Address: Address,
        Phone: Phone,
        Status: Status,
      };
      // console.log("Payload gửi API:", payload);
      await onSaveThemSuaCuaHang(payload);
    } catch (err) {
      console.error("Lỗi khi lưu:", err);
      pushNotification(
        "Có lỗi xảy ra khi lưu. Vui lòng thử lại.",
        "error",
        "TOP_CENTER",
        1000
      );
    } finally {
      setSaving(false); // Kết thúc trạng thái loading
    }
  };

  return (
    <Modal
      show={true}
      size="lg"
      centered
      className="modal-new modal fade text-left"
      animation={true}
    >
      <Modal.Header>
        <h4 className="modal-title">
          <span className="btn-icon-right">
            <img
              src="/app-assets/images/logo-quan-ly-mua-ban-nhap-hang-v2.png"
              alt="logo"
            />
          </span>
          {data.CompanyID === 0
            ? "Thêm mới cửa hàng"
            : "Sửa thông tin cửa hàng"}
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={onClose}
          disabled={saving}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>
                Mã cửa hàng <span className="text-danger">(*)</span>
              </label>
              <input
                type="text"
                className="form-control"
                disabled={CompanyID !== 0}
                value={Code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="Nhập mã cửa hàng"
                readOnly={true}
              />
              {errors.Code && <div className="text-danger">{errors.Code}</div>}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>
                Tên cửa hàng <span className="text-danger">(*)</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={Name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Nhập tên cửa hàng"
              />
              {errors.Name && <div className="text-danger">{errors.Name}</div>}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>
                Địa chỉ <span className="text-danger">(*)</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={Address}
                onChange={(e) => setAddress(e.target.value)}
                placeholder="Nhập địa chỉ"
              />
              {errors.Address && (
                <div className="text-danger">{errors.Address}</div>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>
                Số điện thoại <span className="text-danger">(*)</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={Phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Ví dụ: 0988888888; 0977777777"
              />
              {errors.Phone && (
                <div className="text-danger">{errors.Phone}</div>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Trạng thái</label>
              <select
                className="form-control"
                value={Status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="1">Đang hoạt động</option>
                <option value="0">Tạm ngưng</option>
              </select>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button
          className="btn btn-new-main btn-closenew"
          onClick={onClose}
          disabled={saving}
        >
          <i className="mdi mdi-close"></i>&nbsp; Đóng
        </button>
        <button
          className="btn"
          onClick={handleSave}
          disabled={saving}
          style={{
            background: "#056569",
            color: "white",
            borderRadius: "6px",
            fontSize: "15px",
            textTransform: "none",
          }}
        >
          {saving ? (
            <>
              <span className="spinner-border spinner-border-sm"></span>&nbsp;
              Đang lưu...
            </>
          ) : (
            <>
              <img src="/app-assets/images/icon-add-v2.png" />
              &nbsp; Lưu
            </>
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ThemSuaCuaHang;
